import { render } from "./TrashBin.vue?vue&type=template&id=5355da93&scoped=true"
import script from "./TrashBin.vue?vue&type=script&lang=js"
export * from "./TrashBin.vue?vue&type=script&lang=js"

import "./TrashBin.vue?vue&type=style&index=0&id=5355da93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5355da93"]])

export default __exports__